export enum StorageKey {
    SignInToken = "_sit"
}